import React, { useState } from "react";
// import * as emailjs from "emailjs-com";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { contactConfig } from "../../content_option";
import Wsp from "../../components/wsp/wsp";
import { FaCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export const ContactUs = () => {

  const navigate = useNavigate();
  
  const [formData, setFormdata] = useState({
    email: "",
    name: "",
    message: "",
    loading: false,
    show: false,
    alertmessage: "",
    variant: "",
  });

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setFormdata({ loading: true });

  //   const templateParams = {
  //     from_name: formData.email,
  //     user_name: formData.name,
  //     to_name: contactConfig.YOUR_EMAIL,
  //     message: formData.message,
  //   };

  //   const { REACT_APP_PUBLIC_KEY } = process.env;

  //   emailjs
  //     .send(
  //       contactConfig.YOUR_SERVICE_ID,
  //       contactConfig.YOUR_TEMPLATE_ID,
  //       templateParams,
  //       REACT_APP_PUBLIC_KEY
  //       //contactConfig.YOUR_USER_ID,
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //         setFormdata({
  //           loading: false,
  //           alertmessage: "Gracias por tu mensaje! Te respondo a la brevedad",
  //           variant: "success",
  //           show: true,
  //         });
  //       },
  //       (error) => {
  //         console.log(error.text);
  //         setFormdata({
  //           alertmessage: `No se pudo mandar tu mensaje, intenta nuevamente por favor!, ${error.text}`,
  //           variant: "danger",
  //           show: true,
  //         });
  //         document.getElementsByClassName("co_alert")[0].scrollIntoView();
  //       }
  //     );
  // };

  // const handleChange = (e) => {
  //   setFormdata({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const onClickHandlerToClose = () => {
    navigate("/");
  };

  return (
    <HelmetProvider>
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{meta.title} | Contacto</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <div className="d-flex justify-content-between align-items-baseline">
              <h1 className="display-4 mb-4"> Contacto</h1>{" "}
              <button
                className="back_btn font-italic font-weight-bold btn ac_btn btn_modal"
                onClick={() => onClickHandlerToClose()}
              >
                volver
              </button>
            </div>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="12">
            <Alert
              //show={formData.show}
              variant={formData.variant}
              className={`rounded-0 co_alert ${
                formData.show ? "d-block" : "d-none"
              }`}
              onClose={() => setFormdata({ show: false })}
              dismissible
            >
              <p className="my-0">{formData.alertmessage}</p>
            </Alert>
          </Col>
          <Col lg="5" className="mb-5">
            <h3 className="color_sec py-4">¿Alguna consulta?</h3>
            <address>
              <div className="d-flex flex-row gap-3">
                <strong>Email: </strong>{" "}
                <a href={`mailto:${contactConfig.YOUR_EMAIL}`}>
                  {contactConfig.YOUR_EMAIL}
                </a>
                <p
                  onClick={() => {
                    navigator.clipboard.writeText(contactConfig.YOUR_EMAIL);
                  }}
                >
                  <FaCopy />
                </p>
                <br />
                <br />
              </div>
              <div className="d-flex flex-row gap-3">
                {contactConfig.hasOwnProperty("YOUR_PHONE") ? (
                  <p>
                    <strong>Cel:</strong> {contactConfig.YOUR_PHONE}
                  </p>
                ) : (
                  ""
                )}
                <p
                  onClick={() => {
                    navigator.clipboard.writeText(contactConfig.YOUR_PHONE);
                  }}
                >
                  <FaCopy />
                </p>
              </div>
            </address>
            <p>{contactConfig.description}</p>
            <Wsp />
          </Col>
          {/* <Col lg="7" className="d-flex align-items-center">
            <form onSubmit={handleSubmit} className="contact__form w-100">
              <Row>
                <Col lg="6" className="form-group">
                  <input
                    className="form-control"
                    id="name"
                    name="name"
                    placeholder="Nombre"
                    value={formData.name || ""}
                    type="text"
                    required
                    onChange={handleChange}
                  />
                </Col>
                <Col lg="6" className="form-group">
                  <input
                    className="form-control rounded-0"
                    id="email"
                    name="email"
                    placeholder="Email"
                    type="email"
                    value={formData.email || ""}
                    required
                    onChange={handleChange}
                  />
                </Col>
              </Row>
              <textarea
                className="form-control rounded-0"
                id="message"
                name="message"
                placeholder="Mensaje"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <br />
              <Row>
                <Col lg="12" className="form-group">
                  <button className="btn ac_btn" type="submit">
                    {formData.loading ? "Enviando..." : "Enviar"}
                  </button>
                </Col>
              </Row>
            </form>
          </Col> */}
        </Row>
      </Container>
      <div className={formData.loading ? "loading-bar" : "d-none"}></div>
    </HelmetProvider>
  );
};
